var map = {
	"./round_en.png": "MTYP",
	"./round_th.png": "ncn4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mHRY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa ^\.\/round_.*\.png$
// module id = mHRY
// module chunks = 1